import React from "react";
import ModalContext from "./ModalContext";

class ModalProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            component: null,
            previousActiveElement: null,
            props: {},
        };
    }

    showModal(component, modalProps) {
        if (this.state.visible) {
            return;
        }

        this.setState({
            visible: true,
            previousActiveElement: document.activeElement,
            component,
            props: modalProps,
        });
    }

    hideModal() {
        if (!this.state.visible) {
            return;
        }
        this.setState({ visible: false });

        // Focusing the previousActiveElement synchronously doesn't seem to work
        // Hence the setTimeout
        setTimeout(() => {
            this.state.previousActiveElement.focus();
        }, 30);
    }

    render() {
        return (
            <ModalContext.Provider
                value={{
                    ...this.state,
                    showModal: (component, modalProps) =>
                        this.showModal(component, modalProps),
                    hideModal: () => this.hideModal(),
                }}
            >
                {this.props.children}
            </ModalContext.Provider>
        );
    }
}

export default ModalProvider;
